import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostWorkbookExportFailedAction = {
	type: 'AI_COST_WORKBOOK_EXPORT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostWorkbookExportFailedAction => ({
	type: 'AI_COST_WORKBOOK_EXPORT_FAILED',
	payload,
});
